/* eslint-disable react/jsx-no-useless-fragment */
import React from "react";
import { useSelector } from "react-redux";
import CloseIcon from "../../Common/Svgs/CloseIcon";
import getToastMessage from "../../Utils/getToastMessage";

const ToastMessageModal = ({ visible, onCancel }) => {
  const { toastMessage } = useSelector((state) => state.trips);

  const { icon, iconBackground, title, description } = getToastMessage(
    toastMessage.type,
    toastMessage?.id || 0,
  );

  if (!visible) {
    return <></>;
  }

  return (
    <div className="fixed bottom-12 right-4 h-[150px] p-4 rounded-xl w-[536px] bg-background-white shadow-toastMessage">
      <div className="flex items-center justify-between">
        <div
          className={`flex items-center justify-center w-12 h-12 rounded-full ${iconBackground}`}
        >
          {icon}
        </div>
        <CloseIcon
          onClick={onCancel}
          className="w-4 h-4 cursor-pointer stroke-dark-gray"
        />
      </div>
      <div className="flex flex-col px-2 mt-2 gap-y-2">
        <p className="text-base font-medium text-black capitalize font-poppins">
          {title}
        </p>
        <p className="text-xs font-light text-dark-gray font-poppins">
          {description}
        </p>
      </div>
    </div>
  );
};

export default ToastMessageModal;
